import React from 'react';
import PropTypes from 'prop-types';

const BillingFrequency = ({recurrable}) => {
    return (
        <div className="BillingFrequency">
            <span className="BillingFrequency-text">
                {recurrable
                    ? 'Recurring Monthly (In other words, you’ll be charged monthly until you cancel.)'
                    : 'Non-Recurring Monthly (In other words, we only charge your credit card once for one month.)'}
            </span>
        </div>
    );
};

BillingFrequency.propTypes = {
    recurrable: PropTypes.bool.isRequired,
};

export default BillingFrequency;
